import React, { useState, useEffect } from "react";
import UploadedHistory from "./uplodedHistory";
import UsageHistory from "./usageHistory";
import moment from "moment";
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';

const StampMain = () => {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const [viewPage, setViewpage] = useState('Uploaded History')
    const [commonFilter, setcommonFilter] = useState({
        fromDate: fromDate,
        toDate: toDate
    })

    useEffect(() => {
        setcommonFilter({
            fromDate: fromDate,
            toDate: toDate
        })

    }, [fromDate, toDate]);

    const handlefilters = (type, value) => {
         dispatch({ type: FILTER_ACTION, payload: { [type]: value } });
        setcommonFilter((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const pageHandler = (type) => {
        setViewpage(type)
    }
    return (
        <div className="container-fluid">
            <div className="btn-group-tab " style={{ marginTop: '10px' }}>

                <div className='text-center'>
                    <button className={viewPage == 'Uploaded History' ? 'active' : ''} onClick={(e) => pageHandler('Uploaded History')}>Uploaded History</button>
                </div>
                <div className='text-center'>
                    <button className={viewPage == 'Usage Logs' ? 'active' : ''} onClick={(e) => pageHandler('Usage Logs')}>Usage Logs</button>
                </div>
            </div>
            {viewPage === 'Uploaded History' ?
                <UploadedHistory handlefilters={handlefilters} commonFilter={commonFilter} />
                : ""}
            {viewPage === 'Usage Logs' ?
                <UsageHistory handlefilters={handlefilters} commonFilter={commonFilter} />
                : ""}
        </div>
    )
}
export default StampMain